import { AuthContext } from './Context';
import { useStorage } from '../../utils/useStorage';
import { LoginRequest } from './utils';

// eslint-disable-next-line
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useStorage('token');

  const authenticate = async (nick, senha) => {
    const response = await LoginRequest(nick, senha);

    const payload = { token: response.id, nick, nome: response.nome };

    setToken(payload);
  };

  const logout = async () => {
    setToken(null);
  };

  return (
    <AuthContext.Provider
      value={{
        ...token,
        authenticate,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
